import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedProducts from './components/FeaturedProducts';
import BrandPromise from './components/BrandPromise';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '欧美精品｜正品甄选·高端品质直达',
    description: '欧美精品汇聚全球顶尖品牌，为您精选来自欧洲与美国的高端正品好物。涵盖时尚服饰、护肤美妆、生活家居等品类。',
    url: 'https://www.oumeijingpin.com/',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="欧美精品｜正品甄选·高端品质直达"
        description="欧美精品汇聚全球顶尖品牌，为您精选来自欧洲与美国的高端正品好物。涵盖时尚服饰、护肤美妆、生活家居等品类，每一件欧美精品均经严格品控，品质有保障。"
        keywords="欧美精品,欧美精品正品购买,欧美精品品牌推荐,欧美精品护肤品,欧美精品服饰,欧美精品代购,欧美精品生活方式"
        canonicalUrl="https://www.oumeijingpin.com/"
        jsonLd={webPageJsonLd}
      />
      <Navbar transparent />
      <main>
        <HeroSection />
        <CategoryShowcase />
        <FeaturedProducts />
        <BrandPromise />
        <ArticlePreview />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}